<template>
    <div>

        <rkm-area
            title="Cotas cadastradas"
        >

            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>
            </template>

            <rkm-table
                :fields="fields"
                :items="dados"
                :filter="filter"
                ref="Table"
                class="mt-3"
                responsive
            >
                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.anos"
                                show-default-option
                                default-option-text="Selecione o ano"
                                text-field="cotaAno"
                                v-model="model.cotaAno"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.meses"
                                show-default-option
                                default-option-text="Selecione o mês"
                                text-field="descricao"
                                value-field="id"
                                v-model="model.cotaMes"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter && !model.cotaMes && !model.cotaAno"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(cota)="{ item }">
                    {{ formatQuantidade(item) }}
                </template>

                <template v-slot:cell(transferencia)="{ item }">
                    {{ formatTransferencia(item) }}
                </template>

                <template v-slot:cell(transferenciaRecebida)="{ item }">
                    {{ formatTransferenciaRecebida(item) }}
                </template>

                <template v-slot:cell(utilizada)="{ item }">
                    {{ getUtilizada(item) }}
                </template>

                <template v-slot:cell(saldo)="{ item }">
                    {{ getSaldo(item) }}
                </template>

                <template v-slot:cell(mes)="{ item }">
                    {{ getMes(item.periodo.start) }}
                </template>

                <template v-slot:cell(ano)="{ item }">
                    {{ getAno(item.periodo.start) }}
                </template>

                <template v-slot:cell(actions)="{ index, item }">

                    <rkm-button
                        :color="item.observacao ? 'info' : 'secondary'"
                        small
                        v-rkm-popover.hover.left="{
                            title:'Observação',
                            html:true,
                            content: item.observacao ? item.observacao : 'Nenhuma observação informada.',
                            }"
                    >
                        <i class="fas fa-comment-alt"></i>

                    </rkm-button>

                    <rkm-button
                        @click="$refs.Modal.open(item)"
                        class="colorButton"
                        small
                        title="Detalhamento"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="$emit('copyCota', item)"
                        color="success"
                        small
                        title="Replicar"
                    >
                        <rkm-icon icon="clone" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="$emit('handleAlter', index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        title="Excluir"
                        small
                        @click.stop="handleCota(index, item)"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            :data="data"
            :unidadeId="unidadeId"
            :infraestruturaId="infraestruturaId"
            ref="Modal"
        />
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Components.
import Modal from './transferencia/Modal'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'
import mesesAno from '@/enums/geral/mesesAno'

export default {
    components: { Modal },
    computed: {
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        dados() {

            let totalTranferenciaEnviadas = 0
            let totalTranferenciaRecebida = 0
            let cotaUnidadeSolicitante = this.cotaUnidadeSolicitante
            let filterItems = []

            const ano = this.model.cotaAno
            const mes = this.model.cotaMes

            if (ano != null && mes != null) {

                cotaUnidadeSolicitante = cotaUnidadeSolicitante.filter(i => {return i.periodo.start.substr(6, 4) == ano
                    && i.periodo.start.substr(3, 2) == mes})

            } else if ( ano != null) {

                cotaUnidadeSolicitante = cotaUnidadeSolicitante.filter(i => {return i.periodo.start.substr(6, 4) == ano})

            } else if ( mes != null) {

                cotaUnidadeSolicitante = cotaUnidadeSolicitante.filter(i => {return i.periodo.start.substr(3, 2) == mes})
            }

            filterItems = cotaUnidadeSolicitante.map(unidade => {

                const cota = this.data.model.cotasTransferencia.find((obj =>
                    obj.origemUnidadeId == this.unidadeId
                    && obj.origemInfraestruturaId == this.infraestruturaId
                    && obj.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE
                ));

                let transferencia = 0
                let transferenciaRecebida = 0

                if (cota) {

                    let cotaTransferencia = cota.destino.filter(i => { return i.origemCotaTipoId == unidade.cotaTipoId
                        && moment(
                            unidade.periodo.start.split("/").reverse().join("-")
                        )
                        .isBetween(
                            i.origemInicio.split("/").reverse().join("-"),
                            i.origemFim.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )

                        || i.origemCotaTipoId == unidade.cotaTipoId
                            && moment(
                               unidade.periodo.end.split("/").reverse().join("-")
                            )
                            .isBetween(
                                i.origemInicio.split("/").reverse().join("-"),
                                i.origemFim.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )
                    })

                    let valorUnidade = cotaTransferencia.filter(field => field.origemCotaTipoId == this.enums.tipoCota.VALOR)
                        .reduce((sum, element) => sum + this.formatSumMoney(element.destinoCotaValor), 0);

                    let quantidadeUnidade =  cotaTransferencia.filter(field => field.origemCotaTipoId == this.enums.tipoCota.QUANTIDADE)
                        .reduce((sum, element) => {

                            if (element.destinoCotaQuantidade) {
                                sum = sum + Number(element.destinoCotaQuantidade);
                            }

                            return sum;
                        },0)

                        cotaTransferencia.map(exame => {

                            let cotaExameQuantidade = exame.exames.reduce((sum, element) => {

                                if (element.transferido && element.cotaQuantidadeTransferido) {
                                    sum = sum + Number(element.transferido);
                                }

                                return sum;
                            },0)

                            quantidadeUnidade = quantidadeUnidade + cotaExameQuantidade

                            let cotaExameValor = exame.exames.filter(field => field.cotaValorTransferido > '0,00')
                                .reduce((sum, element) => sum + this.formatSumMoney(element.transferido), 0);

                            valorUnidade = this.formatMoney(valorUnidade, 2)
                            cotaExameValor = this.formatMoney(cotaExameValor, 2)

                            valorUnidade = this.formatSumMoney(valorUnidade) + this.formatSumMoney(cotaExameValor)
                            valorUnidade = this.formatMoney(valorUnidade, 2)
                        })

                        if (unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                            transferencia = valorUnidade
                        } else {

                            transferencia = quantidadeUnidade
                        }
                }

                this.totalTranferenciaEnviadas = totalTranferenciaEnviadas

                let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                    field.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE)

                if (transferenciaLaboratorio.length > 0) {

                    transferenciaLaboratorio = transferenciaLaboratorio.map(field2 => field2.destino)

                    Object.keys(transferenciaLaboratorio).forEach(a => {

                        let recebidos = transferenciaLaboratorio[a]
                            .filter(i => i.destinoUnidadeId == this.unidadeId
                                && i.destinoInfraestruturaId == this.infraestruturaId
                                && i.origemCotaTipoId == unidade.cotaTipoId
                                && moment(
                                   unidade.periodo.start.split("/").reverse().join("-")
                                )
                                .isBetween(
                                    i.destinoInicio.split("/").reverse().join("-"),
                                    i.destinoFim.split("/").reverse().join("-"),
                                    null,
                                    '[]'
                                )

                                || i.destinoUnidadeId == this.unidadeId
                                    && i.destinoInfraestruturaId == this.infraestruturaId
                                    && i.origemCotaTipoId == unidade.cotaTipoId
                                    && moment(
                                         unidade.periodo.end.split("/").reverse().join("-")
                                    )
                                    .isBetween(
                                        i.destinoInicio.split("/").reverse().join("-"),
                                        i.destinoFim.split("/").reverse().join("-"),
                                        null,
                                        '[]'
                                    )
                            )

                        recebidos.forEach(v => {

                            if (unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                                transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                                transferenciaRecebida = this.formatSumMoney(transferenciaRecebida) +
                                    this.formatSumMoney(this.getCotaExame(v))

                                transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                            } else {

                                transferenciaRecebida = transferenciaRecebida + this.getCotaExame(v)
                            }
                        });

                        if (unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                            totalTranferenciaRecebida = this.formatMoney(totalTranferenciaRecebida, 2)
                            transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)

                            totalTranferenciaRecebida = this.formatSumMoney(totalTranferenciaRecebida) +
                                this.formatSumMoney(transferenciaRecebida)

                        } else {

                            totalTranferenciaRecebida = totalTranferenciaRecebida + transferenciaRecebida
                        }
                    })

                    this.totalTranferenciaRecebida = totalTranferenciaRecebida
                }

                return {
                    cota: unidade.cota,
                    cotaTipoId: unidade.cotaTipoId,
                    cotaTipoNome: unidade.cotaTipoNome,
                    cotaQuantidade: unidade.cotaQuantidade,
                    quantidadeUtilizada: unidade.quantidadeUtilizada,
                    cotaValor: unidade.cotaValor,
                    valorUtilizado: unidade.valorUtilizado,
                    periodo: unidade.periodo,
                    transferencia: transferencia,
                    transferenciaRecebida: transferenciaRecebida,
                    id: unidade.id,
                    saldo: unidade.saldo,
                    observacao: unidade.observacao,
                    unidadeTipoId: unidade.unidadeTipoId,
                    utilizada: unidade.utilizada
                }
            })

            return filterItems
        }
    },
    data: () => ({
        items: [],
         model:{
            cotaAno: null,
            cotaMes: null,
        },
        filter: null,
        enums: {
            tipoCota,
            tipoUnidade,
            mesesAno
        },
        utilizadas: null,
        selectedAll: false,
        indeterminate: false,
        columns: [
                { key: 'cotaTipoNome', label: 'Tipo', fixed: true, sortable: true},
                { key: 'cota', label: 'Cota', class: 'text-center', fixed: true, sortable: true },
                { key: 'transferencia', label: 'Transferência enviada', class: 'col-min text-center', sortable: true },
                { key: 'transferenciaRecebida', label: 'Transferência recebida', class: 'col-min text-center', sortable: true },
                { key: 'utilizada', label: 'Utilizada', class: 'col-min text-center', sortable: true },
                { key: 'saldo', label: 'Saldo', class: 'text-center', fixed: true, sortable: true },
                { key: 'mes', label: 'Mês', class: 'text-center', fixed: true, sortable: true },
                { key: 'ano', label: 'Ano', class: 'text-center', fixed: true, sortable: true },
                { key: 'periodo.start', label: 'Inicio', class: 'text-center', fixed: true, sortable: true },
                { key: 'periodo.end', label: 'Fim', class: 'text-center', fixed: true, sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min', fixed: true },
        ],
        selectedColumns: [],
    }),
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.cotaAno = moment().format("YYYY")
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleCota(index, item) {

            this.setLoading()

            this.repositories.saldo.saldoUnidadeSolicitante({
                solicitante_infraestrutura_id: this.infraestruturaId,
                inicio: item.periodo.start.split("/").reverse().join("-"),
                fim: item.periodo.end.split("/").reverse().join("-"),
                cota_tipo_id: item.cotaTipoId,
            })
                .then(response => {

                    if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                        this.utilizadas = this.formatMoney(parseFloat(response.data.valorAgendado), 2)
                    } else {

                        this.utilizadas = response.data.quantidadeAgendada
                    }

                    if (this.utilizadas == 0 || this.utilizadas == '0,00') {

                        this.handleDestroy(index, item)
                    } else {

                        this.showValidationNotification(`Não é possível excluir a cota do período de
                            <strong>${ item.periodo.start }</strong> até <strong>${ item.periodo.end }</strong>, pois
                            já possui agendamentos vinculados a ela.`)

                        return false
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(index, item) {

            this.getCotaAtribuida(item)

            if (this.cotasAtribuidas > 0 || this.cotasAtribuidas > "0,00") {

                this.showValidationNotification(`Não é possível excluir a cota, pois já foi atribuída.`)

                return false
            }

            if (item.transferencia > 0 || item.transferencia > "0,00"
                || item.transferenciaRecebida > 0 || item.transferenciaRecebida > "0,00") {

                this.showValidationNotification(`Não é possível excluir a cota, existem transferências relacionadas.`)

                return false
            }

           const destroy = async () => {
                this.cotaUnidadeSolicitante.splice(index, 1)
                this.data.model.cotasUnidadeSolicitante.push()
           }

           this.showDeleteConfirmation(`Deseja realmente excluir a cota da unidade solicitante?`,
                destroy)
        },
        getCotaAtribuida(unidade) {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            const cota = this.data.model.cotasLaboratorio

            if (cota) {

                cota.map(item => item.cotaLaboratorio.filter(field  => field.cotaTipoId == unidade.cotaTipoId
                    && moment(
                        field.periodo.start.split("/").reverse().join("-")
                    )
                    .isBetween(
                        unidade.periodo.start.split("/").reverse().join("-"),
                        unidade.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        field.periodo.end.split("/").reverse().join("-")
                    )
                    .isBetween(
                        unidade.periodo.start.split("/").reverse().join("-"),
                        unidade.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )).map(unidadeSolicitante => {

                        this.cotaAtribuida = unidadeSolicitante.unidadeSolicitante.filter(field =>
                            field.unidadeSolicitanteId == this.unidadeId
                            && field.infraestruturaSolicitanteId == this.infraestruturaId
                            ).reduce((sum, element) => {

                            if (unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                            return sum
                        },0)

                        this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida

                        Object.keys(unidadeSolicitante).forEach(a => {

                            if (a == "exames") {

                            unidadeSolicitante[a].map(exames => {

                                    this.cotaAtribuida = exames.unidadeSolicitante.filter(field =>
                                        field.unidadeSolicitanteId == this.unidadeId
                                        && field.infraestruturaSolicitanteId == this.infraestruturaId
                                        ).reduce((sum, element) => {

                                        if (unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                                            if (element.cota) {

                                                sum = sum + this.formatSumMoney(element.cota);
                                            }
                                        } else {

                                            if (element.cota) {

                                                sum = Number(sum) + Number(element.cota);
                                            }
                                        }

                                        return sum
                                    },0)

                                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                                })
                            }
                        })
                    })
                )
            }

            if (unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 2)
            } else {

                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 0)
            }
        },
        handleClearFilter() {
            this.filter = null
            this.model.cotaMes = null
            this.model.cotaAno = null
        },
        getCotaExame(item) {

            let cotaExame = 0

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                 cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    cotaExame = this.formatMoney(cotaExame, 2)

                    let destinoCotaValor = this.formatMoney(item.destinoCotaValor, 2)
                    let cotaTotal = this.formatSumMoney(destinoCotaValor) + this.formatSumMoney(cotaExame)

                    return this.formatMoney(cotaTotal, 2)

                } else {

                    return item.destinoCotaValor
                }

            } else {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                return Number(item.destinoCotaQuantidade) + cotaExame
            }
        },
        getMes(value) {

            const data = moment(value, 'DD/MM/YYYY').month() + 1
            return this.enums.mesesAno[data]
        },
        getAno(value) {

            return moment(value, 'DD/MM/YYYY').year()
        },
        getUtilizada(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                return item.valorUtilizado
            } else {

                return this.formatMoney(Number(item.quantidadeUtilizada), 0)
            }
        },
        getSaldo(item) {

            if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                let transferencia = this.formatMoney(item.transferencia, 2)
                let transferenciaRecebida = this.formatMoney(item.transferenciaRecebida, 2)
                let valorUtilizado = this.formatMoney(item.valorUtilizado, 2)

                const saldo = ((this.formatSumMoney(cota) - this.formatSumMoney(valorUtilizado)) - this.formatSumMoney(transferencia))
                    + this.formatSumMoney(transferenciaRecebida)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                const saldo =  (((item.cota) - item.quantidadeUtilizada) - Number(item.transferencia))
                    + Number(item.transferenciaRecebida)

                return this.formatMoney(saldo, 0)
            }
        },
        formatQuantidade(item) {

            const cota = item.cota
            return item.cotaTipoId == this.enums.tipoCota.VALOR ? cota : this.formatMoney(Number(cota), 0)
        },
        formatTransferencia(item) {

            const transferencia = item.transferencia
            return item.cotaTipoId == this.enums.tipoCota.VALOR ? transferencia : this.formatMoney(Number(transferencia), 0)
        },
        formatTransferenciaRecebida(item) {

            const transferenciaRecebida = item.transferenciaRecebida
            return item.cotaTipoId == this.enums.tipoCota.VALOR
                ? transferenciaRecebida : this.formatMoney(Number(transferenciaRecebida), 0)
        }
    },
    mixins: [repository, data, formats],
    props: {
        cotaUnidadeSolicitante: { type: Array, required: true },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        data: { type: Object, required: true },
    },
    watch: {
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.popover{
    max-width: 70%;
}
</style>